import Request, { Methods } from '@libraries/request/'
import ModelHero from '@models/hero'

export default class VotedHeroes extends Request {
  constructor() {
    super()
  }

  get path() {
    return '/apis/voted_heroes'
  }

  get method() {
    return Methods.get
  }

  decode({ data }) {
    let _data = []
    for(let key in data) {
      data[key].hero = new ModelHero(data[key].hero)
      _data.push(Object.assign({day: key}, data[key]))
    }
    return _data
  }

  decodeError(error) {
    return { error: error }
  }
}
